import { Flex, Text } from "@chakra-ui/react";

const PageNotFound = () => {
  return (
    <Flex justifyContent="center" alignItems="center" height="100vh">
      <Text fontSize="4xl">Page Not Found</Text>
    </Flex>
  );
};

export default PageNotFound;
